import { Dialog } from './Dialog';
import { useT, type TFn } from '../i18n';

// ANX-044 — модал со списком клавиатурных шорткатов. Открывается по `?`.

interface Props {
  open: boolean;
  onClose: () => void;
}

interface Row {
  key: string;
  label: string;
}

function rows(t: TFn): Row[] {
  return [
    { key: 'j', label: t('hotkeys.nextConversation') },
    { key: 'k', label: t('hotkeys.prevConversation') },
    { key: '⌘/Ctrl + Enter', label: t('hotkeys.sendMessage') },
    { key: '/', label: t('hotkeys.focusCanned') },
    { key: 'e', label: t('hotkeys.closeConversation') },
    { key: '⌘/Ctrl + K', label: t('hotkeys.focusSearch') },
    { key: '?', label: t('hotkeys.showHelp') },
  ];
}

export function ShortcutsDialog({ open, onClose }: Props) {
  const t = useT();
  return (
    <Dialog open={open} onClose={onClose} title={t('hotkeys.title')} size="sm">
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
        {rows(t).map((r) => (
          <div key={r.key} className="contents">
            <dt className="font-mono text-slate-800">{r.key}</dt>
            <dd className="text-slate-600">{r.label}</dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
}
